import apiTransaksiProduk from '@/api/vo-general/transaksiProduk';

const defaultState = () => ({
	originCompany: {},
	stockistList: [],
	stockistPagination: '',
	stockistQuota: [],
	productList: [],
	productPagination: '',

	packagesList: [],
	packagePagination: '',

	transactionList: [],
	transactionPagination: '',
	transactionDetail: {},

	transactionPOList: [],
	transactionPOPagination: '',
	errorValidation: []
});

const state = defaultState();

const getters = {};

const mutations = {
	setOriginCompany(state, data) {
		state.originCompany = data.results
	},

	setPackageList(state, data) {
		state.packageList = data.results
		state.packagePagination = data.pagination
	},
	setLoadPackageList(state, data) {
		state.packageList = [...state.packageList, ...data.results]
		state.packagePagination = data.pagination
	},

	setStockistList(state, data) {
		state.stockistList = data.results
		state.stockistPagination = data.pagination
	},
	setLoadStockistList(state, data) {
		state.stockistList = [...state.stockistList, ...data.results]
		state.stockistPagination = data.pagination
	},
	setStockistQuota(state, data) {
		state.stockistQuota = data.results
	},
	setProductList(state, data) {
		data.results.map( (el) => {
			el['quantity'] = 1
			el['checked'] = false
			el['total'] = parseInt(el.quantity) * parseInt(el.product_price)
			return el;
		});
		state.productList = data.results;
		state.productPagination = data.pagination;
	},
	setTransactionList(state, data) {
		state.transactionList = data.results
		state.transactionPagination = data.pagination
	},
	setTransactionPOList(state, data) {
		state.transactionPOList = data.results
		state.transactionPOPagination = data.pagination
	},
	setTransactionDetail(state, data) {
		state.transactionDetail = data.results
	},
	setErrorValidation(state, data) {
		state.errorValidation = data
	},
};

const actions = {
	getOriginCompany({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiTransaksiProduk.getOriginCompany(params).then((results) => {
				const data = results.data.data
				commit('setOriginCompany', data)
				resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},

	getPackageList({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiTransaksiProduk.getPackageList(params).then((results) => {
				const data = results.data.data
				commit('setPackageList', data)
				resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},
	getLoadPackageList({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiTransaksiProduk.getPackageList(params).then((results) => {
				const data = results.data.data
				commit('setLoadPackageList', data)
				resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},

	getStockistList({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiTransaksiProduk.getStockistList(params).then((results) => {
				const data = results.data.data
				commit('setStockistList', data)
				resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},
	getLoadStockistList({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiTransaksiProduk.getStockistList(params).then((results) => {
				const data = results.data.data
				commit('setLoadStockistList', data)
				resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},

	getStockistQuota({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiTransaksiProduk.getStockistQuota(params).then((results) => {
				const data = results.data.data
				commit('setStockistQuota', data)
				resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},
	getProductList({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiTransaksiProduk.getProductList(params).then((results) => {
				const data = results.data.data
				commit('setProductList', data)
				resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},
	getTransactionList({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiTransaksiProduk.getTransactionList(params).then((results) => {
				const data = results.data.data
				commit('setTransactionList', data)
				resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},
	getTransactionDetail({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiTransaksiProduk.getTransactionDetail(params).then((results) => {
				const data = results.data.data
				commit('setTransactionDetail', data)
				resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},
	getTransactionPurchaseList({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiTransaksiProduk.getTransactionPurchaseList(params).then((results) => {
				const data = results.data.data
				commit('setTransactionPOList', data)
				resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},
	getPendingPurchaseList({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiTransaksiProduk.getPendingPurchaseList(params).then((results) => {
				const data = results.data.data
				commit('setTransactionPOList', data)
				resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},
	getDeliveryPurchaseList({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiTransaksiProduk.getDeliveryPurchaseList(params).then((results) => {
				const data = results.data.data
				commit('setTransactionPOList', data)
				resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},
	getRejectPurchaseList({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiTransaksiProduk.getRejectPurchaseList(params).then((results) => {
				const data = results.data.data
				commit('setTransactionPOList', data)
				resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},
	getTransactionPurchaseDetail({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiTransaksiProduk.getTransactionDetail(params).then((results) => {
				const data = results.data.data
				commit('setTransactionDetail', data)
				resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},
	addTransaction({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiTransaksiProduk.addTransaction(params).then((results) => {
				const data = results.data
				dispatch('success', data, { root : true });
				resolve(data)
			}).catch((err) => {
				reject(err.response);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},
	addTransactionStockist({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiTransaksiProduk.addTransactionStockist(params).then((results) => {
				const data = results.data
				dispatch('success', data, { root : true });
				resolve(data)
			}).catch((err) => {
				reject(err.response);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},

	uploadPayment({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiTransaksiProduk.uploadPayment(params).then((results) => {
				const data = results.data	
				dispatch('success', data, { root : true })
				resolve(data.data.results)
			}).catch((err) => {
				reject(true);
				// const { data } = err.response;
				// console.log('Err uploadPayment', err.response)
				commit('setErrorValidation', err.response.data.data)
				reject(err.response.data.data)
				// dispatch('errorHandler', data, { root : true });
			});
		});
	},

	errorHandler({ commit }, response) {
		if (response.status !== undefined && response.status === 'unauthorized') {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: response.msg
			}, { root: true });
		} else {
			switch (response.data.error) {
				case 'validation':
					commit('setErrorValidation', response.data.data)
					break;
					
				case 'ERROR':
					commit('setSnackbar', {
						show: true,
						color: 'red darken-2',
						text: response.message
					}, { root: true });
					break;
						
				default:
					commit('setSnackbar', {
						show: true,
						color: 'red darken-2',
						text: 'Terjadi Kesalahan pada sistem, hubungi administrator atau layanan mitra ' + (process.env.VUE_APP_CLIENT_INIT !== undefined) ? process.env.VUE_APP_CLIENT_INIT : 'perusahaan'
					}, { root: true });
					break;

			}
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};